// Skeleton - loading 占位
// v1.9 P0: 加 variant (text/circle/rect) + CardSkeleton/TableSkeleton 预设
import { twMerge } from 'tailwind-merge';

type SkeletonVariant = 'text' | 'rect' | 'circle';

interface SkeletonProps {
  className?: string;
  rows?: number;
  variant?: SkeletonVariant;
}

const VARIANT_CLASS: Record<SkeletonVariant, string> = {
  text: 'rounded h-3',
  rect: 'rounded',
  circle: 'rounded-full',
};

export function Skeleton({ className = 'h-4 w-full', rows = 1, variant = 'text' }: SkeletonProps) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: skeleton placeholders have no stable id
          key={i}
          className={twMerge(
            'bg-surface-2 animate-pulse',
            VARIANT_CLASS[variant],
            variant === 'text' ? 'h-3' : '',
            className,
          )}
        />
      ))}
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="bg-surface border border-line rounded-lg p-4 space-y-3">
      <Skeleton className="h-3 w-1/3" />
      <Skeleton className="h-5 w-2/3" />
      <Skeleton className="h-3 w-1/2" />
    </div>
  );
}

export function TableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="bg-surface border border-line rounded-lg overflow-hidden">
      <div className="px-4 py-2 border-b border-line bg-surface-2">
        <Skeleton className="h-3 w-1/4" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: skeleton placeholders have no stable id
        <div key={i} className="px-4 py-3 border-b border-line last:border-0 flex gap-4">
          <Skeleton className="h-3 w-1/4" />
          <Skeleton className="h-3 w-1/6" />
          <Skeleton className="h-3 w-1/5" />
        </div>
      ))}
    </div>
  );
}

/** Mobile card list skeleton — 用于 mobile 退化的卡片列表 */
export function CardListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="md:hidden space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: skeleton placeholders have no stable id
        <div key={i} className="bg-surface border border-line rounded-lg p-3 space-y-2">
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-3 w-1/3" />
        </div>
      ))}
    </div>
  );
}
